import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";
import sounds from "./sounds";
import { GameEngine } from "./GameEngine";

Vue.use(Vuex);

const slotsPerWeek = 25;

export default new Vuex.Store({
  state: {
    player: new GameEngine(),
    dayAsFloat: 0.0,
    currentSlotIndex: 0,
    gameState: "IntroScreen",
    weekRunning: false,
    weekFinished: false
  },
  getters: {
    currentAction: state => {
      return state.player.actionQueue[state.currentSlotIndex];
    },
    nextAction: state => {
      return state.player.actionQueue[state.currentSlotIndex + 1];
    },
    currentSlotDayIndex: state => {
      return state.currentSlotIndex % 5;
    },
    currentSlotWeekIndex: state => {
      return state.currentSlotIndex % slotsPerWeek;
    },
    weekIndex: state => {
      return Math.floor(state.currentSlotIndex / slotsPerWeek);
    },
    weekActions: (state, getters) => {
      let weekIndex = getters.weekIndex;
      return _.slice(state.player.actionQueue, weekIndex * slotsPerWeek, weekIndex * slotsPerWeek + slotsPerWeek);
    },
    weekExam: (state, getters) => {
      return getters.weekActions[24];
    }
  },
  mutations: {
    incrementSlot(state) {
      state.player.update(state.currentSlotIndex);

      const beforeAction = state.player.actionQueue[state.currentSlotIndex + 1];
      if(beforeAction && beforeAction.topic) {
        // possible topic: ["sleep", "math", "french", "sport", "chill", "gaming"?]
        sounds.play(beforeAction.topic);
      }

      if((state.currentSlotIndex + 1) % slotsPerWeek == 0) {
        state.weekRunning = false;
        state.weekFinished = true;
      } else {
        this.state.currentSlotIndex += 1;
      }
    },
    setNextSlot(state, payload) {
      state.player.setNextSlot(state.currentSlotIndex + 1, payload.action);
    },
    changeGameState(state, payload) {
      state.gameState = payload.name;
    },
    startWeek(state) {
      state.weekRunning = true;
      state.weekFinished = false;
      if(state.currentSlotIndex % slotsPerWeek !== 0) {
        state.currentSlotIndex += 1;
      }
    },
    resetGame(state) {
      state.player.reset();
      state.dayAsFloat = 0;
      state.currentSlotIndex = 0;
      state.weekRunning = false;
    }
  },
  actions: {
    incrementSlot(context) {
      console.log("incrementSlot called");
      context.commit("incrementSlot");
    },
    setNextSlot(context, payload) {
      context.commit("setNextSlot", payload);
    },
    changeGameState(context, payload) {
      context.commit("changeGameState", payload);
    },
    resetGame(context, payload) {
      context.commit("resetGame", payload);
    }
  }
});
